<bix-loader *ngIf="isLoading"> </bix-loader>

<router-outlet></router-outlet>
